import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { FormGroup, FormControl, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { Subject } from 'rxjs';
import * as i2 from 'app-services-library';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/button';
import * as i6 from 'primeng/tooltip';
import * as i7 from '@angular/material/icon';
import * as i8 from 'primeng/inputswitch';
import { PrimengLibraryModule } from 'primeng-library';

class VdSwitchGroupService {
    constructor() { }
}
VdSwitchGroupService.ɵfac = function VdSwitchGroupService_Factory(t) { return new (t || VdSwitchGroupService)(); };
VdSwitchGroupService.ɵprov = i0.ɵɵdefineInjectable({ token: VdSwitchGroupService, factory: VdSwitchGroupService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdSwitchGroupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { hiddenView: a0 }; };
function VdSwitchGroupComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "p-inputSwitch", 12);
    i0.ɵɵlistener("onChange", function VdSwitchGroupComponent_div_11_Template_p_inputSwitch_onChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.handleChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, !(ctx_r0.groupElementProperty == null ? null : ctx_r0.groupElementProperty.isTwostate)));
} }
const _c1 = function (a0, a1) { return { "btn-save": a0, "btn-cancel": a1 }; };
function VdSwitchGroupComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "button", 14);
    i0.ɵɵlistener("click", function VdSwitchGroupComponent_div_12_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleTristateChange(false); });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 15);
    i0.ɵɵlistener("click", function VdSwitchGroupComponent_div_12_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleTristateChange(true); });
    i0.ɵɵelementStart(5, "span", 4);
    i0.ɵɵtext(6, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 16);
    i0.ɵɵlistener("click", function VdSwitchGroupComponent_div_12_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.handleTristateChange(null); });
    i0.ɵɵelementStart(8, "span", 4);
    i0.ɵɵtext(9, "Unspecified");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1, ctx_r1.state === false, ctx_r1.state != false))("disabled", ctx_r1.disabledFields);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c1, ctx_r1.state == true, ctx_r1.state != true))("disabled", ctx_r1.disabledFields);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c1, ctx_r1.state == null || ctx_r1.state === "", ctx_r1.state != null))("disabled", ctx_r1.disabledFields);
} }
class VdSwitchGroupComponent {
    constructor(store, appServicesLibraryService, cdr) {
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.cdr = cdr;
        this.group = new FormGroup({});
        this.showTextAreaSection = false;
        this.userAction = false;
        this.observableSubscription$ = new Subject();
        this.switchOptions = [];
        this.state = '';
        this.fieldId1 = '';
        this.fieldId2 = '';
        this.fieldId3 = '';
        this.disabledFields = false;
    }
    ngOnInit() {
        var _a, _b, _c, _d;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.fieldId1 = this.uuid();
        this.fieldId2 = this.uuid();
        this.fieldId3 = this.uuid();
        this.fromGrpName = (this.formControlName) ? this.formControlName : `${this.inputParams.label.toUpperCase().replace(/ /g, '_')}_${this.uuid()}`;
        this.switch_field_val = (this.inputParams.value && ((_b = (_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.switch_field) !== '') ? (((_d = (_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.switch_field) == true) ? true : false : '';
        this.state = (this.switch_field_val === true) ? true : (this.switch_field_val === false) ? false : null;
        //let switch_field_val = this.inputParams.value && this.inputParams.value.switch_field ? (this.inputParams.value.switch_field == true) : false;
        //let switch_field_val = this.inputParams?.value?.switch_field || '';
        //let switch_field_val = (this.inputParams?.value?.switch_field == true)? true: (this.inputParams?.value?.switch_field == false)? false: '';
        let additional_info_for_switch_field_val = this.inputParams.value && this.inputParams.value.additional_info_for_switch_field ? this.inputParams.value.additional_info_for_switch_field : '';
        this.group.addControl(this.fromGrpName, new FormGroup({
            switch_field: new FormControl(this.switch_field_val),
            additional_info_for_switch_field: new FormControl(additional_info_for_switch_field_val)
        }));
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
        }
        this.group.controls[this.fromGrpName].get("switch_field").valueChanges.subscribe(selectedValue => {
            this.cdr.detectChanges();
            this.handleChange(selectedValue, 'FORMVALUECHANGES');
        });
        this.showTheTextArea();
        this.cdr.detectChanges();
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    // translet() {
    //   setTimeout(() => {
    //     this.referenceLibraryService.transletConversion();
    //   }, 600);
    // }
    toggleState(val) {
        this.state = val;
        this.handleChange(val, 'FORMVALUECHANGES');
        //this.group.get(this.fromGrpName).get("switch_field").setValue(val);
        //this.group.get(this.fromGrpName).get("switch_field").updateValueAndValidity();
    }
    uuid() {
        const val1 = Date.now().toString(36);
        const val2 = Math.random().toString(36).substring(2);
        return val1 + val2;
    }
    toggleInputFields() {
        // console.log(this.inputData.stepStatusCode)
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
            this.disabledFields = true;
        }
        else {
            this.group.enable();
            this.disabledFields = false;
        }
    }
    showTheTextArea() {
        if (this.inputParams.groupElementProperty && this.inputParams.groupElementProperty.whenTextAreaShown) {
            if (this.inputParams.groupElementProperty.whenTextAreaShown === 'off') {
                this.showTextAreaSection = this.inputParams.value && this.inputParams.value.switch_field ? false : true;
            }
            else if (this.inputParams.groupElementProperty.whenTextAreaShown === 'on') {
                this.showTextAreaSection = this.inputParams.value && this.inputParams.value.switch_field ? true : false;
            }
            else {
                this.showTextAreaSection = true;
            }
        }
    }
    // ngOnChanges() {
    // }
    handleChange($event, type) {
        if ($event === '') {
            this.showTextAreaSection = false;
        }
        else {
            if (this.inputParams.groupElementProperty.whenTextAreaShown === 'off') {
                this.showTextAreaSection = type && type === 'FORMVALUECHANGES' ? !$event : !$event.checked;
            }
            else if (this.inputParams.groupElementProperty.whenTextAreaShown === 'on') {
                this.showTextAreaSection = type && type === 'FORMVALUECHANGES' ? $event : $event.checked;
            }
            else {
                this.showTextAreaSection = true;
            }
        }
        this.cdr.detectChanges();
    }
    handleTristateChange(val) {
        this.state = val;
        if (val !== null) {
            this.group.controls[this.fromGrpName].get("switch_field").setValue(val);
        }
        else {
            this.group.controls[this.fromGrpName].get("switch_field").setValue('');
        }
        // this.handleChange(val, 'FORMVALUECHANGES');
    }
}
VdSwitchGroupComponent.ɵfac = function VdSwitchGroupComponent_Factory(t) { return new (t || VdSwitchGroupComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
VdSwitchGroupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdSwitchGroupComponent, selectors: [["vd-switch-group"]], inputs: { validation: "validation", readonly: "readonly", sublabel: "sublabel", groupElementProperty: "groupElementProperty", formControlName: "formControlName", group: "group", inputParams: "inputParams", inputData: "inputData", groupName: "groupName" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 20, vars: 9, consts: [[3, "formGroup"], [1, "text-field", 3, "formGroupName"], [1, "questionBox", "p-0", "m-0"], [1, "leftLabel", "p-0", "m-0", "pr-1", 3, "ngStyle"], [1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", "pTooltip", "Select explicitly the required option", "tooltipPosition", "top", 1, "p-button-text", "p-button-rounded", 2, "color", "lightblue", "height", "1.457rem"], ["class", "rightSwitch p-0 m-0", 3, "ngClass", 4, "ngIf"], ["class", "p-buttonset rightSwitch p-0 m-0", "style", "min-width: 280px !important;", 4, "ngIf"], [1, "p-0", "m-0"], [1, "explanation-text"], ["rows", "2", "id", "textArea", "formControlName", "additional_info_for_switch_field", "placeholder", "Enter", 1, "form-control", 3, "ngClass", "ngStyle"], [1, "rightSwitch", "p-0", "m-0", 3, "ngClass"], ["formControlName", "switch_field", 1, "pl-2", 3, "onChange"], [1, "p-buttonset", "rightSwitch", "p-0", "m-0", 2, "min-width", "280px !important"], ["pButton", "", "type", "button", "title", "No", 1, "btn-cancel", "btn-generic", 2, "font-size", "10px !important", "width", "25px", "padding", "0px !important", 3, "ngClass", "disabled", "click"], ["pButton", "", "type", "button", "title", "Yes", 1, "btn-cancel", "btn-generic", 2, "font-size", "10px !important", "width", "25px", "padding", "0px !important", 3, "ngClass", "disabled", "click"], ["pButton", "", "type", "button", "title", "Unspecified", 1, "btn-cancel", "btn-generic", 2, "font-size", "10px !important", "width", "60px", "padding", "0px !important", 3, "ngClass", "disabled", "click"]], template: function VdSwitchGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "label");
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵelementStart(8, "button", 5);
        i0.ɵɵelementStart(9, "mat-icon");
        i0.ɵɵtext(10, "info");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, VdSwitchGroupComponent_div_11_Template, 2, 3, "div", 6);
        i0.ɵɵtemplate(12, VdSwitchGroupComponent_div_12_Template, 10, 15, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 8);
        i0.ɵɵelementStart(14, "div", 8);
        i0.ɵɵelementStart(15, "label", 9);
        i0.ɵɵelementStart(16, "small", 4);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "br");
        i0.ɵɵelement(19, "textarea", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", ctx.groupElementProperty == null ? null : ctx.groupElementProperty.labelStyle);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.groupElementProperty == null ? null : ctx.groupElementProperty.questionLabel, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.groupElementProperty == null ? null : ctx.groupElementProperty.isTwostate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.groupElementProperty == null ? null : ctx.groupElementProperty.isTwostate));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.groupElementProperty == null ? null : ctx.groupElementProperty.textAreaLabel, "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.showTextAreaSection === false ? "disabledTextarea" : "")("ngStyle", ctx.groupElementProperty == null ? null : ctx.groupElementProperty.textAreaStyle);
    } }, directives: [i3.NgControlStatusGroup, i3.FormGroupDirective, i3.FormGroupName, i4.NgStyle, i5.ButtonDirective, i6.Tooltip, i7.MatIcon, i4.NgIf, i3.DefaultValueAccessor, i3.NgControlStatus, i3.FormControlName, i4.NgClass, i8.InputSwitch], styles: [".text-field[_ngcontent-%COMP%]{width:100%;margin-bottom:15px}.text-field[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin:0!important;padding:0!important}.text-field[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:12px;color:#3b3b3b;margin-bottom:4px}.text-field[_ngcontent-%COMP%]   .overflowHidden[_ngcontent-%COMP%]{overflow:hidden;height:auto}.text-field[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.text-field[_ngcontent-%COMP%]   .sublabel[_ngcontent-%COMP%]{font-size:12px}.custom-questions-group[_ngcontent-%COMP%]{width:90%;display:flex;justify-content:space-between}.custom-questions-group[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:16px!important;display:flex;max-width:calc(100% - 60px)!important;float:left}.custom-questions-group[_ngcontent-%COMP%]   .questionToggle[_ngcontent-%COMP%]{width:8%}.custom-questions-group[_ngcontent-%COMP%]   .p-inputswitch[_ngcontent-%COMP%]{background:none!important}.custom-questions-group[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]{width:auto}.explanation-text[_ngcontent-%COMP%]{max-width:70%!important}.disabledTextarea[_ngcontent-%COMP%]{pointer-events:none;background:#cecece}.questionBox[_ngcontent-%COMP%]{display:inline-flex;width:-moz-fit-content;width:fit-content;max-width:98%}.questionBox[_ngcontent-%COMP%]   .leftLabel[_ngcontent-%COMP%]{max-width:calc(100% - 60px)!important;float:left}.questionBox[_ngcontent-%COMP%]   .rightSwitch[_ngcontent-%COMP%]{float:right;width:10%}.questionBox[_ngcontent-%COMP%]   .p-checkbox[_ngcontent-%COMP%]:not(.p-checkbox-disabled)   .p-checkbox-box.p-highlight[_ngcontent-%COMP%]:hover{border:2px solid #ced4da;background:#fff;width:20px;height:20px;color:#495057;border-radius:3px;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}.descriptionBox[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start}[_nghost-%COMP%]     .p-inputswitch .p-inputswitch-slider{height:22px}.switch-note[_ngcontent-%COMP%]{font-size:12px}textarea[_ngcontent-%COMP%]{resize:none}.hiddenView[_ngcontent-%COMP%]{display:none}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdSwitchGroupComponent, [{
        type: Component,
        args: [{
                selector: 'vd-switch-group',
                templateUrl: 'vd-switch-group.component.html',
                styleUrls: ['vd-switch-group.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.AppServicesLibraryService }, { type: i0.ChangeDetectorRef }]; }, { validation: [{
            type: Input
        }], readonly: [{
            type: Input
        }], sublabel: [{
            type: Input
        }], groupElementProperty: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], groupName: [{
            type: Input
        }] }); })();

class VdSwitchGroupModule {
}
VdSwitchGroupModule.ɵfac = function VdSwitchGroupModule_Factory(t) { return new (t || VdSwitchGroupModule)(); };
VdSwitchGroupModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdSwitchGroupModule });
VdSwitchGroupModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdSwitchGroupModule, { declarations: [VdSwitchGroupComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [VdSwitchGroupComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdSwitchGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [VdSwitchGroupComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [VdSwitchGroupComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-switch-group
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdSwitchGroupComponent, VdSwitchGroupModule, VdSwitchGroupService };
//# sourceMappingURL=vd-switch-group.js.map
